import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Header from "../../components/Header/Header";
import { useAuth } from "../../context/AuthContext";
import { apiError } from "../../api/client";
import "./Auth.scss";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/quiz";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(apiError(err, "Invalid email or password"));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth">
      <Header />
      <main className="auth__card rise-1">
        <span className="auth__eyebrow">Welcome back</span>
        <h1 className="auth__title">Pick up where you left off</h1>
        <p className="auth__subtitle">Log in to see your saved finds.</p>

        <form className="auth__form" onSubmit={handleSubmit} noValidate autoComplete="off">
          {error && (
            <p className="auth__error" role="alert">
              {error}
            </p>
          )}

          <label className="auth__label" htmlFor="email">
            Email
          </label>
          <input
            id="email"
            type="email"
            className="auth__input"
            autoComplete="off"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label className="auth__label" htmlFor="password">
            Password
          </label>
          <input
            id="password"
            type="password"
            className="auth__input"
            autoComplete="off"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button className="auth__submit" type="submit" disabled={submitting}>
            {submitting ? "Logging in…" : "Log in"}
          </button>
        </form>

        <p className="auth__switch">
          New here? <Link to="/signup">Create an account</Link>
        </p>
      </main>
    </div>
  );
}
